import elemento_tipo_model from '@/shared/models/elemento_tipo_model';
import forma_model from '@/shared/models/forma_model';
import material_prima_familia_model from '@/shared/models/materia_prima_familia_model';
import suaje_model from '@/shared/models/suaje_model';

export default {
  AnchoTotal: 0,
  AltoTotal: 0,
  AnchoMaterial: 0,
  Base: 0,
  CantidadCambios: 1,
  CantidadColoresAdhesivo: 0,
  CantidadColoresFrente: 0,
  CantidadColoresLiner: 0,
  CantidadPolimeros: 0,
  Codigo: null,
  CodigoCotizacion: null,
  CodigoElementoTipo: null,
  CodigoForma: null,
  CodigoMateriaPrimaFamilia: null,
  CodigoSuaje: null,
  CodigoAdaptador: null,
  CotizacionCantidadCosto: [],
  CotizacionElementoProceso: [], // Este es un array de objetos.
  // CotizacionElementoTinta: [], // Este es un array de objetos.
  Desarrollo: 0,
  ElementoTipo: { ...elemento_tipo_model },
  Engranaje: 0,
  EtiquetasDesarrollo: 0,
  EtiquetasEje: 0,
  Forma: { ...forma_model },
  GapDesarrollo: 0,
  GapEje: 0,
  ItemElemento: 0,
  Laterales: 0,
  AnchoMinimoMaterial: 0,
  LargoMinimoMaterial: 0,
  MargenSuperior: 0,
  MateriaPrimaFamilia: { ...material_prima_familia_model },
  MedidaDesarrollo: 0,
  MedidaEje: 0,
  Paginas: 0,
  PaquetesPorCaja: 0,
  RotacionImposicion: null,
  Sellado: 0,
  Solapa: 0,
  Suaje: { ...suaje_model },
  Adaptador: null,
  UnidadMedida: 'mm',
};
